import { Box } from "@mui/material"
import React, { ReactNode } from "react"

interface AspectRatioBoxProps {
  children: ReactNode
  ratio?: number
}

const AspectRatioBox: React.FC<AspectRatioBoxProps> = ({ children, ratio = 1 }) => {
  return (
    <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          "& > *": { width: "100%", height: "100%" },
        }}
      >
        {children}
      </Box>
      <Box sx={{ paddingBottom: (1 / ratio) * 100 + "%" }} />
    </Box>
  )
}

export default AspectRatioBox
